<template>
  <div id="app">
    <app-nav v-if="this.$route.name !== 'Administration' && this.$route.name !== 'AdministrationLogin'"></app-nav>
    <router-view/>
    <app-footer v-if="this.$route.name !== 'Administration' && this.$route.name !== 'AdministrationLogin'"></app-footer>
    <appGDPRPrompt v-if="this.$route.name !== 'Administration' && this.$route.name !== 'AdministrationLogin'"/>
  </div>
</template>

<script>
import Nav from "./components/shared/Nav";
import Footer from "./components/shared/Footer";
import GDPRPrompt from "./components/shared/GDPRPrompt";
export default {
  name: "App",
  components: {
    appNav: Nav,
    appFooter: Footer,
    appGDPRPrompt: GDPRPrompt
  },
  watch: {
    "$route.name"(to, from) {
      window.scrollTo(0, 0);
    }
  },
  mounted() {
    // this is for vh to work on mobile devices
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }
};
</script>

<style>
/* @import url('https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700&subset=cyrillic'); */
@font-face {
  font-family: "Roboto";
  src: url("./assets/fonts/Roboto-Thin.woff2") format("woff2"),
    url("./assets/fonts/Roboto-Thin.woff") format("woff");
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: "Roboto";
  src: url("./assets/fonts/Roboto-Regular.woff2") format("woff2"),
    url("./assets/fonts/Roboto-Regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Roboto";
  src: url("./assets/fonts/Roboto-Light.woff2") format("woff2"),
    url("./assets/fonts/Roboto-Light.woff") format("woff");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "Roboto";
  src: url("./assets/fonts/Roboto-Medium.woff2") format("woff2"),
    url("./assets/fonts/Roboto-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Roboto";
  src: url("./assets/fonts/Roboto-Bold.woff2") format("woff2"),
    url("./assets/fonts/Roboto-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}
/* CUSTOM ICONS FONT */
/* Generated by Glyphter (http://www.glyphter.com) on  Mon Jul 09 2018*/
@font-face {
  font-family: "alcomet";
  src: url("./assets/fonts/alcomet.eot");
  src: url("./assets/fonts/alcomet.eot?#iefix") format("embedded-opentype"),
    url("./assets/fonts/alcomet.woff") format("woff"),
    url("./assets/fonts/alcomet.ttf") format("truetype"),
    url("./assets/fonts/alcomet.svg#alcomet") format("svg");
  font-weight: normal;
  font-style: normal;
}
[class*="icon-"]:before {
  display: inline-block;
  font-family: "alcomet";
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-logo_white:before {
  content: "\0041";
}
.icon-instagram:before {
  content: "\0042";
}
.icon-linkedin:before {
  content: "\0043";
}
.icon-fb:before {
  content: "\0044";
}
.icon-youtube:before {
  content: "\0045";
}
.icon-share:before {
  content: "\0046";
}
.icon-language:before {
  content: "\0047";
}
.icon-close:before {
  content: "\0048";
}
.icon-down:before {
  content: "\0049";
}
.icon-gallery:before {
  content: "\004a";
}
.icon-img:before {
  content: "\004b";
}
.icon-img_down:before {
  content: "\004c";
}
.icon-img_up:before {
  content: "\004d";
}
.icon-left:before {
  content: "\004e";
}
.icon-right:before {
  content: "\004f";
}
.icon-mail:before {
  content: "\0050";
}
.icon-request:before {
  content: "\0051";
}
.icon-search:before {
  content: "\0052";
}
.icon-zoom:before {
  content: "\0053";
}
.icon-call:before {
  content: "\0054";
}
.icon-1:before {
  content: "\0055";
}
.icon-2:before {
  content: "\0056";
}
.icon-3:before {
  content: "\0057";
}
.icon-4:before {
  content: "\0058";
}
.icon-5:before {
  content: "\0059";
}
.icon-6:before {
  content: "\005a";
}
.icon-contacts:before {
  content: "\0061";
}
.icon-event:before {
  content: "\0062";
}
.icon-news:before {
  content: "\0063";
}
.icon-product:before {
  content: "\0064";
}
.icon-model:before {
  content: "\0065";
}
.icon-cast:before {
  content: "\0066";
}
.icon-construction:before {
  content: "\0067";
}
.icon-rolled:before {
  content: "\0068";
}
.icon-ind:before {
  content: "\0069";
}
.icon-pack:before {
  content: "\006a";
}
.icon-share:before {
  content: "\006b";
}
.icon-asset-40:before {
  content: "\006c";
}
.icon-asset-47:before {
  content: "\006d";
}
.icon-asset-44:before {
  content: "\006e";
}
.icon-asset-43:before {
  content: "\006f";
}
.icon-asset-42:before {
  content: "\0070";
}
.icon-asset-48:before {
  content: "\0071";
}
.icon-more:before {
  content: "\0072";
}
.icon-addcalendar:before {
  content: "\0073";
}
.icon-calendar:before {
  content: "\0074";
}
.icon-pdf:before {
  content: "\0075";
}
.icon-pin:before {
  content: "\0076";
}
.icon-download:before {
  content: "\0077";
}
.icon-list:before {
  content: "\0078";
}
.icon-agenda:before {
  content: "\0079";
}

html,
body {
  margin: 0;
  padding: 0;
  min-width: 320px;
}

* {
  margin: 0;
  outline: 0;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  color: #004787;
  font-family: "Ubuntu", sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  padding: 0;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  display: inline;
}
a {
  cursor: pointer;
  text-decoration: none;
}
p a {
  color: #0086ff;
  text-decoration: underline;
}
.alcomet {
  font-family: "alcomet";
}
.strong,
strong {
  font-weight: 700;
}
.indent::first-letter {
  margin-left: 20px;
}
.stop-scrolling {
  overflow: hidden;
}
/* DATEPICKER */
.custom-datepicker {
  margin: 0 auto !important;
  width: 80% !important;
}
.custom-calendar {
  background-color: transparent !important;
  border: none !important;
  width: 100% !important;
}
.day__month_btn.up {
  display: none !important;
}
.vdp-datepicker__calendar header .prev,
.vdp-datepicker__calendar header .next {
  border: 1px solid #c8d9e5 !important;
  border-radius: 50% !important;
  background-color: transparent !important;
  content: "da" !important;
  height: 50px !important;
  position: absolute !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  width: 50px !important;
}
.vdp-datepicker__calendar header .prev:after,
.vdp-datepicker__calendar header .next:after {
  align-items: center !important;
  border: 0 !important;
  border-radius: 50%;
  display: inline-flex !important;
  content: "N" !important;
  font-family: "alcomet" !important;
  font-size: 16px !important;
  height: 100% !important;
  justify-content: center !important;
  left: 0 !important;
  margin: 0 !important;
  position: absolute !important;
  top: 0 !important;
  text-indent: initial !important;
  transform: translateX(0) translateY(0) !important;
  width: 100% !important;
}
.vdp-datepicker__calendar header .next:after {
  content: "O" !important;
}
.vdp-datepicker__calendar header .prev:not(.disabled):hover,
.vdp-datepicker__calendar header .next:not(.disabled):hover,
.vdp-datepicker__calendar header .up:not(.disabled):hover {
  background-color: #d9e4ec !important;
}
.vdp-datepicker__calendar header .prev {
  left: -10% !important;
}
.vdp-datepicker__calendar header .next {
  right: -10% !important;
}
.vdp-datepicker__calendar .cell.day-header {
  color: #839ab8 !important;
  text-transform: uppercase !important;
}
.vdp-datepicker .vdp-datepicker__calendar .cell.selected {
  background-color: transparent !important;
  border: none !important;
  border-radius: 6px !important;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border-color: transparent !important;
}
.vdp-datepicker__calendar .cell {
  margin: 0 4% !important;
  width: 6.285714285714286% !important;
}
.vdp-datepicker__calendar .cell.highlighted {
  background-color: #d9e4ec !important;
  border: 1px solid #8fa4bf !important;
  border-radius: 6px !important;
}
.vdp-datepicker__calendar .today {
  font-weight: 700 !important;
}
.news-preview-content .ql-video {
  width: 100% !important;
  height: 30vw;
}
@media screen and (max-width: 1000px) {
  .vdp-datepicker__calendar header .prev {
    left: -15% !important;
  }
  .vdp-datepicker__calendar header .next {
    right: -15% !important;
  }
  .vdp-datepicker__calendar .cell {
    padding: 0;
  }
}
@media screen and (max-width: 600px) {
  .custom-datepicker {
    width: 100% !important;
  }
  .vdp-datepicker__calendar .cell.highlighted {
    background-color: transparent !important;
    border: none !important;
    text-decoration: underline;
  }
  .vdp-datepicker__calendar header .prev,
  .vdp-datepicker__calendar header .next {
    border: 1px solid #004787 !important;
    height: 40px !important;
    width: 40px !important;
  }
  .vdp-datepicker__calendar header .prev:after,
  .vdp-datepicker__calendar header .next:after {
    font-size: 14px !important;
  }
  .vdp-datepicker__calendar header .prev {
    left: -40px !important;
  }
  .vdp-datepicker__calendar header .next {
    right: -40px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue